import useCurrentUser from 'hooks/useCurrentUser';

/**
 * Returns true if the current user is an account administrator (not a CA admin).
 */
export default function useIsCurrentUserAdministrator(): boolean {
  const currentUser = useCurrentUser();
  return Boolean(
    currentUser.is_account_administrator && !currentUser.is_ca_admin
  );
}
